import React, { useLayoutEffect, useRef, useState } from 'react';
import { UpArrowIcon } from '@/assets/icons/icons';
import type { HelpAssistantComposerProps } from '../../types';
import styles from '../../AppHelpCenter.module.scss';

const HelpAssistantComposer = ({
  placeholder,
  disabled,
  onSend,
}: HelpAssistantComposerProps) => {
  const [value, setValue] = useState('');
  const trimmed = value.trim();
  const inputRef = useRef<HTMLTextAreaElement>(null);

  // Grows with the text; CSS max-height caps it and scrolls past that.
  useLayoutEffect(() => {
    const input = inputRef.current;
    if (!input) return;
    input.style.height = 'auto';
    input.style.height = `${input.scrollHeight}px`;
  }, [value]);

  // One question at a time; the user can keep typing while an answer loads.
  const send = () => {
    if (!trimmed || disabled) return;
    onSend(trimmed);
    setValue('');
  };

  // Enter sends; Shift+Enter adds a new line.
  const handleKeyDown = (event: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      send();
    }
  };

  return (
    <div className={styles.assistantComposerWrap}>
      <div className={styles.assistantComposer}>
        <textarea
          ref={inputRef}
          className={styles.assistantComposerInput}
          rows={1}
          placeholder={placeholder}
          aria-label={placeholder}
          value={value}
          onChange={(event) => setValue(event.target.value)}
          onKeyDown={handleKeyDown}
        />
        <button
          type='button'
          aria-label='Send'
          className={styles.assistantSendButton}
          disabled={!trimmed || disabled}
          onClick={send}
        >
          <UpArrowIcon
            size={24}
            color='currentColor'
            style={{ marginRight: 0 }}
          />
        </button>
      </div>
      <p className={styles.assistantDisclaimer}>
        Answers are generated from the help articles and can be wrong. Check the
        linked article before changing settings.
      </p>
    </div>
  );
};

export default HelpAssistantComposer;
